import { useEffect } from 'react';
import { useGlobalLogo } from '@/quote/hooks/useGlobalLogo';
import { NewJoveLogo, RemoteLogo, WamoLogo } from '@jove-frontend/uikit';
import clsx from 'clsx';

const GlobalLogoIconView = ({ className }: { className?: string }) => {
  const { logoSource, logoSrc, setLogoSrc } = useGlobalLogo();

  useEffect(() => {
    if (logoSource) {
      let logoSrc = null;
      switch (logoSource) {
        case 'wamo':
          logoSrc = <WamoLogo className="h-[16px] w-[126px]" />;
          break;
        case 'remote':
          logoSrc = <RemoteLogo />;
          break;
        default:
          logoSrc = (
            <NewJoveLogo isWhite={true} className="h-[24px] w-[76px]" />
          );
          break;
      }
      setLogoSrc(logoSrc);
    }
  }, [logoSource]);

  return <div className={clsx(className)}>{logoSrc}</div>;
};

export default GlobalLogoIconView;
